import * as Sentry from '@sentry/react'
import {useEffect} from 'react'
import {useDispatch} from 'react-redux'

import {useQuery} from '~/hooks'
import {deviceInfoSlice} from '~/reducers/deviceInfo'
import {AppDispatch} from '~/stores'
import {isInApp, isWanxiang, isZY} from '~/utils'
import {
  parseDeviceInfoQuery,
  persistDeviceInfoCache,
  restoreDeviceInfoCache,
} from '~/utils/deviceInfoCache'

export function InitDeviceInfo() {
  const dispatch = useDispatch<AppDispatch>()
  const query = useQuery()

  useEffect(() => {
    const ua = window.navigator.userAgent
    if (!isInApp(ua) && !isWanxiang(ua) && !isZY(ua)) {
      return
    }

    const deviceinfoFromQuery = parseDeviceInfoQuery(query.deviceinfo as string)
    if (deviceinfoFromQuery) {
      dispatch(deviceInfoSlice.actions.set(deviceinfoFromQuery))
      persistDeviceInfoCache(deviceinfoFromQuery)
      Sentry.setTag('uid', deviceinfoFromQuery.h_m)
      return
    }

    // 三方支付回跳通常不带 deviceinfo，从 sessionStorage 恢复
    const cachedDeviceInfo = restoreDeviceInfoCache()
    if (cachedDeviceInfo) {
      dispatch(deviceInfoSlice.actions.set(cachedDeviceInfo))
      Sentry.setTag('uid', cachedDeviceInfo.h_m)
    }
  }, [dispatch, query])

  useEffect(() => {}, [dispatch])
  return null
}
